<template>
  <v-btn icon @click="orientacoesIncidencia()"
    ><v-icon size="22">mdi-help-circle-outline</v-icon></v-btn
  >
</template>

<script>
import { mapMutations } from "vuex";
export default {
  methods: {
    ...mapMutations("dependentes", ["setModalAjuda", "setAjudaSelecionada"]),
    orientacoesIncidencia() {
      this.setAjudaSelecionada({
        title: "Legendas",
        funcao: "legendasalariofamilia",
        tituloModal: "Legendas Incidência"
      });
      this.setModalAjuda(true);
    },
  },
};
</script>

<style>
</style>